module.exports = __webpack_public_path__ + "img/direction_straight.0317417b.jpg";